/* eslint-disable no-unused-vars */
import { useDispatch, useSelector } from 'react-redux';
import { Form, Checkbox } from 'antd';
import DokanCard from '../card/DokanCard';
import DokanCheckBox from '../form/DokanCheckBox';
import DokanInputLabel from '../form/DokanInputLabel';
import DokanTinyEditor from '../form/DokanTinyEditor';
import { handleProductInput } from '../../redux/products/productsActions';
import DokanIcons from '../icon/DokanIcons';

function Advanced() {
    const dispatch = useDispatch();
    const handleChangeInput = (name, value = '', e = null) => {
        dispatch(handleProductInput(name, value, e));
    };
    const getInputData = useSelector((state) => state.products.productInputData);
    const setInputData = getInputData.reviews_allowed;
    return (
        <>
            <DokanCard hasTitle hasDivider cardTitle="Advanced" hasSvg svgIcon="#product_general">
                <DokanInputLabel>Purchase Note</DokanInputLabel>
                <DokanTinyEditor
                    setHeight="200px"
                    FormInputName="purchase_note"
                    onValueChange={handleChangeInput}
                />
                {/* <DokanCheckBox
                    label="Enable reviews"
                    FormInputName="reviews_allowed"
                    FormItemLabel="Enable Review"
                    isIcon
                    icon="#checkbox_info"
                    checkValue="reviews_allowed"
                    onValueChange={handleChangeInput}
                /> */}

                <Form.Item name="reviews_allowed">
                    <div className="grid gap-y-1 justify-between min-w-full">
                        <div className="flex flex-1 pt-4">
                            <div>
                                <Checkbox
                                    className="dokan-checkbox"
                                    defaultChecked={setInputData}
                                    onChange={(e) =>
                                        handleChangeInput('reviews_allowed', e.target.checked)
                                    }
                                >
                                    <span className="text-sm font-light">Enable reviews</span>
                                </Checkbox>
                            </div>

                            <div className="mt-1">
                                <DokanIcons icon="#checkbox_info" size="3" />
                            </div>
                        </div>
                    </div>
                </Form.Item>
            </DokanCard>
        </>
    );
}

export default Advanced;
